"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("../core");
var atoms_1 = require("../atoms");
exports.BrowserWindow = function (props) {
    return (react_1.default.createElement(core_1.Flexbox, { boxShadow: "0 2px 100px -10px rgba(0, 0, 0, 0.2)", borderRadius: "10px", border: "1px solid #dee3f3", flexDirection: "column", width: "100%", height: "100%" },
        react_1.default.createElement(core_1.Flexbox, { flex: "0 0 40px", p: 10, px: 20, borderBottom: "1px solid", borderColor: "#dee3f3", alignItems: "center" },
            react_1.default.createElement(atoms_1.WindowButton, null),
            react_1.default.createElement(atoms_1.WindowButton, null),
            react_1.default.createElement(atoms_1.WindowButton, null)),
        react_1.default.createElement(core_1.Box, { p: 0, flex: "1 1 100%", height: "100%", maxHeight: "100%", style: { overflowX: "hidden", overflowY: "auto" } }, props.children)));
};
